type ValidationResult = {
  error: boolean;
  errorMessage: string;
};

type ValidationRule = (input: string) => ValidationResult;

export const dateValidator =
  (errorMessage: string): ValidationRule =>
  (inputToValidate: string): ValidationResult => {
    const DateRegEx = /^\d{4}-\d{2}-\d{2}$/;
    if (!DateRegEx.test(inputToValidate) || Number.isNaN(Date.parse(inputToValidate))) {
      return { error: true, errorMessage };
    }
    return { error: false, errorMessage };
  };

export const dateSpanValidator =
  (errorMessage: string, minDate: Date, maxDate?: Date): ValidationRule =>
  (inputToValidate: string): ValidationResult => {
    const DateRegEx = /^\d{4}-\d{2}-\d{2}$/;
    if (!DateRegEx.test(inputToValidate) || Number.isNaN(Date.parse(inputToValidate))) {
      return { error: true, errorMessage };
    }
    if (new Date(inputToValidate) < minDate) {
      return { error: true, errorMessage: `Datumet måste vara tidigast den ${minDate.toISOString().slice(0, 10)}` };
    }
    if (maxDate && new Date(inputToValidate) > maxDate) {
      return { error: true, errorMessage: `Datumet måste vara senast den ${minDate.toISOString().slice(0, 10)}` };
    }
    return { error: false, errorMessage };
  };

const checkIfFutureDate = (inputToValidate: string): boolean => {
  const dateToValidate = new Date(inputToValidate);
  const today = new Date();
  return dateToValidate > today;
};

// YYYYMMDD
export const dateOfBirthValidator =
  (errorMessage: string): ValidationRule =>
  (inputToValidate: string): ValidationResult => {
    const DateRegEx = /^\d{8}$/;

    if (
      !DateRegEx.test(inputToValidate) ||
      Number.isNaN(
        Date.parse(`${inputToValidate.slice(0, 4)}-${inputToValidate.slice(4, 6)}-${inputToValidate.slice(6, 8)}`)
      )
    ) {
      return { error: true, errorMessage };
    }
    return { error: false, errorMessage };
  };
